import { ReactNode } from 'react';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { GlobalStyles } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { useConfig } from './ConfigProvider';  // أو المسار الصحيح
import '@fontsource/readex-pro/200.css';
import '@fontsource/readex-pro/300.css';
import '@fontsource/readex-pro/400.css';
import '@fontsource/readex-pro/500.css';
import '@fontsource/readex-pro/600.css';
import '@fontsource/readex-pro/700.css';

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const { direction } = useConfig();

  const theme = createTheme({
    direction, // ✅ هذا أهم شي
    palette: {
      primary: {
        main: '#1f4059',
        light: '#53C295',
        dark: '#1D3D58',
      },
      secondary: {
        main: '#004AAD',
        light: '#077DCD',
        dark: '#7b1fa2',
      },
    },
    typography: {
      fontFamily: 'Readex Pro',
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          '*': {
            fontFamily: 'Readex Pro !important',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
          },
          sizeLarge: {
            height: 45,
          }
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 8,
          },
        },
      },
    },
  });

  const globalStyles = (
    <GlobalStyles
      styles={{
        '*': {
          fontFamily: 'Readex Pro !important',
        },
      }}
    />
  );

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {globalStyles}
      {children}
    </MuiThemeProvider>
  );
};
